import React from "react";
import {
  Drawer,
  Box,
  Typography,
  List,
  ListItem,
  Divider,
  Switch,
  FormControlLabel,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useFeatureFlags } from "~/providers/FeatureFlagsProvider";
import { useAppNavDrawer } from "~/providers/app-nav-drawer";
import {
  INCIDENT_BANNER_HEIGHT,
  IncidentIndicator,
} from "~/components/IncidentBanner/useIncidentBanner";
import { useAuth } from "~/login/provider";

export function FeatureFlagsModal() {
  const { features, toggleFeature, isModalOpen, closeModal } =
    useFeatureFlags();
  const navDrawer = useAppNavDrawer();
  const { incident } = useAuth();

  const incidentOffset =
    incident?.data?.indicator !== IncidentIndicator.NONE &&
    incident?.showIncidentBanner
      ? INCIDENT_BANNER_HEIGHT
      : 0;
  const topOffset =
    navDrawer.navbarHeight + incidentOffset + navDrawer.bannerOffset;

  return (
    <Drawer
      id="feature-flags-drawer"
      anchor="right"
      open={isModalOpen}
      onClose={closeModal}
      sx={{
        "& .MuiDrawer-paper": {
          width: 400,
          p: 3,
          top: `${topOffset}px`,
          height: `calc(100% - ${topOffset}px)`,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h5" fontWeight={700}>
          Feature Flags
        </Typography>
        <IconButton onClick={closeModal} aria-label="Close">
          <CloseIcon />
        </IconButton>
      </Box>

      <List>
        {features.map((feature, index) => (
          <React.Fragment key={feature.name}>
            <ListItem disablePadding sx={{ py: 1 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={feature.enabled}
                    onChange={() => toggleFeature(feature.name)}
                    color="primary"
                  />
                }
                label={
                  <Box>
                    <Typography variant="body1" fontWeight={500}>
                      {feature.name}
                    </Typography>
                    {feature.description && (
                      <Typography variant="body2" color="text.secondary">
                        {feature.description}
                      </Typography>
                    )}
                  </Box>
                }
                sx={{ width: "100%", m: 0 }}
              />
            </ListItem>
            {index < features.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>
    </Drawer>
  );
}
